import LogsFiltersContainer from './logsFilters.container';

export default LogsFiltersContainer;
